export {
  fetchPlanets,
  fetchPlanetsStart,
  fetchPlanetsSuccess,
  fetchPlanetsFail,
} from './planets';

export {
  fetchPlanet,
  fetchPlanetStart,
  fetchPlanetSuccess,
  fetchPlanetFail,
} from './planet';

export {
  fetchStarships,
  fetchStarshipsStart,
  fetchStarshipsSuccess,
  fetchStarshipsFail,
} from './starships';

export {
  fetchStarship,
  fetchStarshipStart,
  fetchStarshipSuccess,
  fetchStarshipFail,
} from './starship';

export {
  fetchVehicles,
  fetchVehiclesStart,
  fetchVehiclesSuccess,
  fetchVehiclesFail,
} from './vehicles';

export {
  fetchVehicle,
  fetchVehicleStart,
  fetchVehicleSuccess,
  fetchVehicleFail,
} from './vehicle';

export {
  fetchPeople,
  fetchPeopleStart,
  fetchPeopleSuccess,
  fetchPeopleFail,
} from './people';

export {
  fetchPerson,
  fetchPersonStart,
  fetchPersonSuccess,
  fetchPersonFail,
} from './person';

export {
  fetchFilms,
  fetchFilmsStart,
  fetchFilmsSuccess,
  fetchFilmsFail,
} from './films';

export {
  fetchFilm,
  fetchFilmStart,
  fetchFilmSuccess,
  fetchFilmFail,
} from './film';

export {
  fetchSpecies,
  fetchSpeciesStart,
  fetchSpeciesSuccess,
  fetchSpeciesFail,
} from './species';

export {
  fetchSpecie,
  fetchSpecieStart,
  fetchSpecieSuccess,
  fetchSpecieFail,
} from './specie';
